import React from 'react';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectExtension } from 'flow/selectors/ExtensionSelectors';
import IconButton from 'flow/components/ui-components/IconButton';
import Icon from 'flow/components/ui-components/Icon';
import ContactAvatar from 'flow/components/ui-components/ContactAvatar';
import { twMerge } from 'tailwind-merge';
import { extractName } from 'flow/utils';
import SettingRow from 'flow/components/Setting/SettingRow';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    extensionKey: ExtensionKey;
    onClickAdd: (key: ExtensionKey) => void;
    disabled?: boolean;
}
const ExtensionSelectable = ({
    extensionKey,
    onClickAdd,
    disabled = false,
}: Props) => {
    const extension = useAppSelector((state) =>
        selectExtension(state, extensionKey),
    );

    const { i18next } = useAppContext();
    const handleClick = () => {
        onClickAdd(extensionKey);
    };

    if (!extension) return null;

    return (
        <SettingRow
            key={extension.get('key')}
            className="h-12"
            cta={
                <IconButton
                    aria-label={i18next.t('chatsettings.add')}
                    className="reveal-on-hover-or-focus flex"
                    onClick={handleClick}
                    disabled={disabled}
                >
                    <Icon iconKey="add" />
                </IconButton>
            }
        >
            <ContactAvatar
                contact={extension.get('contact')}
                size="small"
                fallBackBackgroundColorClass={twMerge(
                    'group-hover:bg-gray-300 bg-gray-200',
                )}
                lazyLoad={true}
            />

            <div
                className={twMerge(
                    'truncate',
                    disabled ? 'text-gray-400' : 'text-gray-800',
                )}
            >
                {extractName(
                    extension.get('contact'),
                    i18next.t('Contact.Unknown'),
                )}
            </div>
        </SettingRow>
    );
};

export default ExtensionSelectable;
